import { Parser } from "app-scheme-utils/lib/litb";

let SchemeUtils: Parser;

export const getSchemeUtils = (isInApp: boolean) => {
	if (!SchemeUtils) {
		SchemeUtils = new Parser(isInApp);
	}
	return SchemeUtils;
};

export const GetAutoLink = (link: string) => {
	if (!link) {
		return "";
	}
	if (SchemeUtils.isInApp) {
		return SchemeUtils.convertToAutoLink(link);
	}
	return link;
};

export const clickJump = (link: string) => {
	if (SchemeUtils.isInApp) {
		SchemeUtils.jumpWebLink(link);
	} else {
		open(link);
	}
};
